import { Injectable } from '@angular/core';
import { ServiceService } from './service.service';


@Injectable({
  providedIn: 'root'
})
export class PersonasService {


  constructor(private servi: ServiceService) { }


  public getListado() {
      return this.servi.get('personas/getlistado');
  }

  public getPersona(id: number) {
    return this.servi.get('personas/getPersona/' + id);
  }

  public GetObtenerinfomacion() {
    return this.servi.get('personas/GetObtenerinformacion');
  }

  public cambiarEstado(id: number) {
       return this.servi.get('personas/CambiarEstado/' + id );
  }

  public GuardarPersona(data) {
    var formData = new FormData();
    for ( var nombre in data ) {
       if (data[nombre]) {
          formData.append(nombre, data[nombre]);
       }
    }
    return this.servi.postFile(`personas/PostGuardarPersona`, formData);
  }

}
